import { render, staticRenderFns } from "./MesDashboardPage.vue?vue&type=template&id=8a683654&scoped=true&"
import script from "./MesDashboardPage.vue?vue&type=script&lang=js&"
export * from "./MesDashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./MesDashboardPage.vue?vue&type=style&index=0&id=8a683654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a683654",
  null
  
)

export default component.exports